import { useNavigate } from "react-router-dom";

import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card } from "@/components/ui/card";
import CallAgentMetricsTable from "components/call_metrics_table/CallMetricsTableV3";
import setPageTitle from "helpers/title";
import { useAppTabs } from "hooks/useAppTabs";
import TotalCallsChart from "routes/dashboard/TotalCallsChart";
import CallDashboardSummaryStats from "routes/dashboard/CallDashboardSummaryStats";
import CallsBreakDownByDispositionChart from "routes/dashboard/CallBreakdownByDisposition";
import CallsBreakDownByDialSessionChart from "routes/dashboard/CallsBreakDownByDialSessionChart";
import { CallDashboardFilters } from "routes/dashboard/CallDashboardFilters";

const tabs = [
  {
    value: "totalCalls",
    label: "Total Calls",
    Content: TotalCallsChart,
  },
  {
    value: "agentMetrics",
    label: "Agent Metrics",
    Content: CallAgentMetricsTable,
  },
  {
    value: "dispositionBreakdown",
    label: "Disposition Breakdown",
    Content: CallsBreakDownByDispositionChart,
  },
  {
    value: "dialSessionBreakdown",
    label: "Dial Session Breakdown",
    Content: CallsBreakDownByDialSessionChart,
  },
];
const tabValues = tabs.map(t => t.value);

const CallDashboard = () => {
  const { activeTab } = useAppTabs({
    basePath: "/call_dashboard",
    defaultTab: tabValues[0],
  });
  const navigate = useNavigate();
  setPageTitle("Call Dashboard");

  // Navigates itself rather than through useAppTabs so the dashboard filters
  // in the query string survive a tab change.
  const handleTabChange = tab => {
    navigate({
      pathname: `/call_dashboard/${tab}`,
      search: window.location.search,
    });
  };

  return (
    <div className="tw:flex tw:w-full tw:flex-col tw:flex-1">
      <div className="tw:flex tw:flex-1 tw:gap-4 tw:w-full">
        <CallDashboardFilters />

        <div className="tw:flex tw:flex-1 tw:flex-col tw:min-w-0">
          <CallDashboardSummaryStats />
          <Tabs
            value={activeTab}
            onValueChange={handleTabChange}
            className="tw:flex-1 tw:gap-4"
          >
            <TabsList>
              {tabs.map(t => (
                <TabsTrigger key={t.value} value={t.value}>
                  {t.label}
                </TabsTrigger>
              ))}
            </TabsList>
            {tabs.map(({ value, Content }) => (
              <TabsContent key={value} value={value}>
                <Card className="tw:h-full tw:flex tw:p-4">
                  <Content />
                </Card>
              </TabsContent>
            ))}
          </Tabs>
        </div>
      </div>
    </div>
  );
};
export default CallDashboard;
